<template>
  <v-row no-gutters class="min-height-100 new-wrapper" v-if="serviceByIds">
    <v-col cols="12" v-if="serviceByIds.title === 'Kommunale Wärmeplanung'">
      <WaermeplanungView />
    </v-col>
    <v-col cols="12" v-else-if="serviceByIds.title === 'FAQ Kommunale Wärmeplanung'">
        <WaermeFAQ />
    </v-col>
    <v-col cols="12" v-else-if="serviceByIds.title === 'Einspeisebeteiligung'">
      <Einspeisebeteiligung :service="serviceByIds" />
    </v-col>
    <v-col cols="12" v-else-if="serviceByIds.title === 'Mobile Mapping'">
      <MobileMapping />
    </v-col>
    <v-col cols="12" v-else-if="serviceByIds.title === 'NEW Erleben'">
      <MomentsView />
    </v-col>
    <v-col cols="12" v-else-if="serviceByIds.title === 'Nachhaltigkeit bei der NEW'">
      <nachhaltigkeits-view />
    </v-col>
    <template v-else-if="serviceByIds.title === 'Social Media Datenbank'">
    <v-col  :cols="colSize" class="new-wrapper px-10 py-4">
      <SocialMediaDb />
    </v-col>
      <v-col
          cols="12" sm="4"
          class="contact_container pl-4"
          v-if="serviceByIds.title !== 'Mobile Mapping'"
      >
        <RightColumnGroup
            :communePartner="communePartner"
            :communeRegionalLeader="communeRegionalLeader"
            :contentObject="serviceByIds"
        />
      </v-col>
    </template>
    <template v-else>
    <!-- MAIN CONTENT -->
      <v-col :cols="colSize" class="pa-10">
      <v-row>
        <v-col align="left" cols="12">
          <breadcrumbs />
          <span class="custom-header-text new-font-bold">
            {{ serviceByIds.title }}
          </span>
          <p
            v-if="serviceByIds.subtitle"
            class="font-weight-bold mt-5 mb-2"
          >
            {{ serviceByIds.subtitle }}
          </p>
          <v-row v-if="serviceByIds.hero" class="px-3 mt-0 mb-0">
            <v-img :src="`${baseUrl}${serviceByIds.hero.url}`"></v-img>
          </v-row>
        </v-col>
      </v-row>

      <!-- TEXT SECTION 1 -->
      <v-row no-gutters class="mt-5">
        <vue-markdown-it
          v-if="serviceByIds.content1"
          :source="serviceByIds.content1"
          id="content1"
        />
      </v-row>

        <iframe v-if="serviceByIds.embeddedWebsite !== null" :src="serviceByIds.embeddedWebsite" style="width: 100%" :style="{'aspect-ratio': $vuetify.breakpoint.smAndDown ? 0.5 : 1.33 }" />

        <v-row no-gutters class="mt-5" v-if="serviceByIds.FAQ">
          <v-col cols="12">
            <faq-container :faqs="serviceByIds.FAQ" />
          </v-col>
        </v-row>

      <!-- SERVICE/SUBSERVICE ANGEBOT -->
      <template v-if="subServices.length != 0">
        <v-row no-gutters class="mt-6 text-h5" id="service-overview-title">
          {{
            isNewEmployee && hasKonzession
              ? "Unsere Kommunen:"
              : "Unser Angebot:"
          }}
        </v-row>
        <v-row class="mt-3">
          <v-col
            v-for="(subService, index) in subServices"
            :key="subService.id"
            :cols="$vuetify.breakpoint.smAndDown ? 12 : 6"
            :class="
              $vuetify.breakpoint.smAndDown
                ? 'pa-1'
                : index % 2
                ? 'pl-2'
                : 'pr-2'
            "
          >
            <ButtonCard :object="subService" routeName="sub-service" />
          </v-col>
        </v-row>
      </template>

      <!-- CAROUSEL OR IMAGE-->
      <template v-if="images">
        <v-row v-if="images.length > 1" no-gutters class="mt-6 new-iframe">
          <Carousel :slides="images" />
        </v-row>
        <v-row v-else-if="images.length == 1" class="px-3 mt-6">
          <v-img class="new-iframe" :src="`${baseUrl}${images[0].url}`"></v-img>
          <p v-if="images[0].caption" class="text-caption">
            {{ images[0].caption }}
          </p>
        </v-row>
      </template>

      <!-- TEXT SECTION 2 -->
      <v-row no-gutters class="mt-5">
        <vue-markdown-it
          v-if="serviceByIds.content2"
          :source="serviceByIds.content2"
          id="content2"
        />
      </v-row>

        <v-row v-if="serviceByIds.title === 'Mobilität'">
          <v-col id="wunschladesaeulen">
            <h2>Wunschladesäule</h2>
            <p>
              <b>Wünschen Sie sich einen Platz für eine Ladesäule</b><br />
              Wie nehmen Ihren Vorschlag im Rahmen der Bürgerbeteiligung für neue
              Standorte von Ladesäulen entgegen!
            </p>

            <ol>
              <li>
                Wunschstandort per Klick in der Karte auswählen und festlegen
              </li>
              <li>Formular ausfüllen und abschicken</li>
              <li>E-Mail-Adresse verifizieren</li>
            </ol>
            <p>
              <br />
              FERTIG
              <br />Wir prüfen Ihren Standortvorschlag und schalten ihn zum
              Bürger:innenvoting frei.
            </p>
            <div style="-webkit-overflow-scrolling: touch; overflow-y: scroll;">
              <iframe
                  class="new-iframe"
                  height="740"
                  id="iframe"
                  marginheight="0px"
                  marginwidth="0px"
                  name="iframe"
                  scrolling="yes"
                  :src="getLadesaeulenUrl"
                  width="100%"
              ></iframe>
            </div>
          </v-col>
        </v-row>

      <QuartiersentwicklungView v-if="serviceByIds.title === 'Quartiersentwicklung'"
                                :contact-person="serviceByIds.personsInCharge[0]" />

      <RightColumnGroup
        v-if="$vuetify.breakpoint.xs"
        :communePartner="communePartner"
        :communeRegionalLeader="communeRegionalLeader"
        :contentObject="serviceByIds"
      />
    </v-col>

    <!-- RIGHT SIDE CONTENT - ANSPRECHPARTNER, DOWNLOADS, INTERESSANTES -->
    <v-col
      v-if="$vuetify.breakpoint.smAndUp"
      cols="4"
      class="contact_container pl-4"
    >
      <RightColumnGroup
        :communePartner="communePartner"
        :contentObject="serviceByIds"
        :communeRegionalLeader="communeRegionalLeader"
      />
    </v-col>
    </template>
  </v-row>
</template>

<script>
import { checkIconName } from "@/mixins/checkIconName";
import Carousel from "@/components/layout/Carousel.vue";
import ButtonCard from "@/components/layout/ButtonCard.vue";
import RightColumnGroup from "@/components/layout/RightColumnGroup.vue";
import WaermeplanungView from "@/views/Waermeplanung.vue";
import WaermeFAQ from "@/views/WaermeFAQ.vue";
import QuartiersentwicklungView from "@/views/QuartiersentwicklungView.vue";
import {mapActions, mapGetters} from "vuex";
import { metricEventTypes, metricParents } from "@/lib";
import FaqContainer from "../components/ui/FaqContainer.vue";
import Einspeisebeteiligung from "./Einspeisebeteiligung.vue";
import VueMarkdownIt from "vue-markdown-it";
import MobileMapping from "@/views/MobileMapping.vue";
import SocialMediaDb from "@/views/SocialMediaDb.vue";
import NachhaltigkeitsView from "@/views/NachhaltigkeitsView.vue";
import MomentsView from "@/views/MomentsView.vue";
import Breadcrumbs from "@/components/ui/Breadcrumbs.vue";

export default {
  name: "ServiceDetail",
  components: {
    Breadcrumbs,
    MomentsView,
    NachhaltigkeitsView,
    SocialMediaDb,
    MobileMapping,
    Einspeisebeteiligung,
    FaqContainer,
    QuartiersentwicklungView,
    WaermeFAQ,
    WaermeplanungView,
    Carousel,
    ButtonCard,
    RightColumnGroup,
    VueMarkdownIt
  },
  mixins: [checkIconName],

  data: () => ({
    baseUrl: process.env.VUE_APP_API_BASE_URL,
  }),
  computed: {
    ...mapGetters('user', ['enableMoments', 'getLadesaeulenUrl']),
    colSize() {
      if (this.$vuetify.breakpoint.smAndUp) return 8;
      else return 12;
    },
    images() {
      return this.serviceByIds.images;
    },

    menuItems() {
      return this.$store.getters["navigation/getMainNavObject"];
    },

    serviceId() {
      return Number(this.$route.params.serviceId);
    },

    serviceAreaId() {
      return Number(this.$route.params.serviceAreaId);
    },

    serviceAreaByServiceAreaId() {
      return this.menuItems.serviceAreaItems.filter(
        s => s.id == this.serviceAreaId
      )[0];
    },

    serviceByIds() {
      let serviceArea = this.menuItems.serviceAreaItems.filter(
        s => s.id == this.serviceAreaId
      )[0];
      return serviceArea.services.find(s => s.id == this.serviceId);
    },

    communePartner() {
      return this.$store.getters["user/userCommunePartner"];
    },

    communeRegionalLeader() {
      return this.$store.getters["user/userCommuneRegionalLeader"];
    },
    isNewEmployee() {
      return this.$store.getters["user/isNewEmployee"];
    },
    communeServices() {
      return this.$store.getters["serviceOverview/getCommunesForService"](
        this.serviceByIds.title
      );
    },
    communeSubServices() {
      return this.$store.getters["serviceOverview/getCommunesForSubService"](
        this.serviceByIds.title
      );
    },
    hasKonzession() {
      return [
        "Stromlieferung",
        "Stromversorgung",
        "Erdgaslieferung",
        "Erdgasversorgung"
      ].includes(this.serviceByIds.title);
    },
    subServices() {
      if(this.enableMoments) return this.serviceByIds.subServices;
      else return this.serviceByIds.subServices.filter(s => s.title !== 'NEW Erleben');
    }
  },
  mounted() {
    this.postHeartbeat({
      name: this.serviceByIds.title,
      type: metricEventTypes.PAGE_VISIT,
      parent: metricParents.SERVICE,
    });
  },
  methods: {
    ...mapActions('metrics', ['postHeartbeat']),
    getCommuneServiceUrl(id) {
      return `/service-area/${this.serviceAreaId}/service/${id}`;
    }
  }
};
</script>
